import { PalletCustomPrices } from 'interfaces';

export const DEFAULT_PALLET_CUSTOM_PRICES: () => PalletCustomPrices = () => ({
   edhpPalletPrice: 0,
   euroPalletPrice: 0,
   halfPalletNDHPPrice: 0,
   quarterPalletCDHPPrice: 0,
});
